import React, { createContext, useState, useContext, useEffect } from 'react';

const PWAContext = createContext();

export const PWA_BANNER_ENABLED = true;

export function PWAProvider({ children }) {
  const [hasShownBannerThisSession, setHasShownBannerThisSession] = useState(false);

  useEffect(() => {
    setHasShownBannerThisSession(false);
  }, []);

  return (
    <PWAContext.Provider value={{ 
      hasShownBannerThisSession, 
      setHasShownBannerThisSession,
      isEnabled: PWA_BANNER_ENABLED 
    }}>
      {children}
    </PWAContext.Provider>
  );
}

export function usePWA() {
  const context = useContext(PWAContext);
  if (!context) {
    throw new Error('usePWA must be used within a PWAProvider');
  }
  return context;
} 